
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('g',{attrs:{"id":"alert-circle"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M11 22a11 11 0 1111-11 11 11 0 01-11 11zm0-20a9 9 0 109 9 9 9 0 00-9-9z","id":"Ellipse_17","data-name":"Ellipse 17"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M11 12a1 1 0 01-1-1V7a1 1 0 012 0v4a1 1 0 01-1 1z","id":"Line_5","data-name":"Line 5"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M11 16a1 1 0 110-2 1 1 0 010 2z","id":"Line_6","data-name":"Line 6"}})])])])])
          )
        }
      }
    